import React from 'react';
import './SandboxStats.scss';

const SandboxStats = ({ stats, loading, error }) => {
  if (loading) {
    return (
      <div className="sandbox-stats">
        <div className="stats-loading">Loading sandbox statistics...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="sandbox-stats error">
        <div className="stats-error">{error}</div>
      </div>
    );
  }

  if (!stats) {
    return null;
  }

  const { totalMessageLimit, sentMessageCount, canSend } = stats;
  const remainingMessages = totalMessageLimit - sentMessageCount;
  const usagePercentage = (sentMessageCount / totalMessageLimit) * 100;

  return (
    <div className="sandbox-stats">
      <div className="stats-content">
        <div className="stat-item">
          <label>Messages Sent</label>
          <div className="stat-value">
            {sentMessageCount} / {totalMessageLimit}
          </div>
        </div>

        <div className="stat-item">
          <label>Remaining</label>
          <div className="stat-value highlight">
            {remainingMessages} messages
          </div>
        </div>

        <div className="progress-bar-container">
          <div className="progress-bar">
            <div 
              className={`progress-fill ${usagePercentage >= 90 ? 'critical' : usagePercentage >= 70 ? 'warning' : 'normal'}`}
              style={{ width: `${Math.min(usagePercentage, 100)}%` }}
            />
          </div>
          <span className="progress-text">{usagePercentage.toFixed(1)}% used</span>
        </div>
      </div>
    </div>
  );
};

export default SandboxStats;

